import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const HeartIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="29" viewBox="0 0 31 29" className={className} onClick={onClick}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#DF6541" stroke="#F6F4F4" strokeWidth="1.5" transform="translate(-805 -2924)">
          <g transform="translate(477 2712)">
            <g>
              <g>
                <path d="M350.368 213c4.19 0 7.206 3.627 7.586 7.95 0 0 .204 1.073-.246 3.005-.614 2.63-2.056 4.968-4.001 6.751L343.413 240l-10.12-9.294c-1.945-1.784-3.387-4.12-4-6.752-.451-1.931-.247-3.005-.247-3.005.38-4.322 3.397-7.949 7.586-7.949 3.11 0 5.61 1.962 6.781 4.77 1.171-2.808 3.844-4.77 6.955-4.77z"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default HeartIcon;
